module.exports = __webpack_public_path__ + "img/esp.4b0ec73b.png";